import ThemesService from "../services/ThemesService";

export const namespaced = true;

export const state = {
  themesByCategory: [],
  themesByCategoryLoading: false,
  isFetchingThemesByCategory: false
};
export const mutations = {
  SET_THEMES_BY_CATEGORY(state, value) {
    state.themesByCategory = value;
  },
  SET_THEMES_BY_CATEGORY_LOADING_TO_FALSE(state) {
    state.themesByCategoryLoading = false;
  },
  SET_THEMES_BY_CATEGORY_LOADING_TO_TRUE(state) {
    state.themesByCategoryLoading = true;
  },
  SET_IS_FETCHING_THEMES_BY_CATEGORY_TO_FALSE(state) {
    state.isFetchingThemesByCategory = false;
  },
  SET_IS_FETCHING_THEMES_BY_CATEGORY_TO_TRUE(state) {
    state.isFetchingThemesByCategory = true;
  }
};
export const actions = {
  updateThemesByCategory({ commit }) {
    commit("SET_IS_FETCHING_THEMES_BY_CATEGORY_TO_TRUE");
    commit("SET_THEMES_BY_CATEGORY_LOADING_TO_TRUE");
    ThemesService.getThemesByCategories()
      .then(response => {
        commit("SET_THEMES_BY_CATEGORY", response.data);
        localStorage.setItem("themesByCategory", JSON.stringify(response.data));
      })
      .catch(err => console.log(err))
      .finally(() => {
        commit("SET_IS_FETCHING_THEMES_BY_CATEGORY_TO_FALSE");
        commit("SET_THEMES_BY_CATEGORY_LOADING_TO_FALSE");
      });
  }
};
export const getters = {
  activitiesThemes(state) {
    return state.themesByCategory.filter(
      item => item.nameEn === "activities"
    )[0];
  },
  ambiancesThemes(state) {
    return state.themesByCategory.filter(
      item => item.nameEn === "ambiances"
    )[0];
  },
  transportsThemes(state) {
    return state.themesByCategory.filter(
      item => item.nameEn === "transports"
    )[0];
  },
  travellersThemes(state) {
    return state.themesByCategory.filter(
      item => item.nameEn === "travellers"
    )[0];
  },
  isThemesByCategoryHaveBeenFetched(state) {
    return state.themesByCategory.length > 0 ? true : false;
  }
};
